import type { FunctionComponent } from "react";
import { useState } from "react";

import { getTimezoneShortLabel } from "../../timezone/timezones";
import type { AutomationCandidate } from "../../types/candidate";
import { TimeZoneModal } from "../TimeZoneModal/TimeZoneModal";
import * as S from "./style";
import { t } from "i18next";
import type { Placements } from "@smartsuite/react-ui/lib";
import { Tooltip, Icon, Text, TooltipButton } from "@smartsuite/react-ui/lib";
import { GrayColors } from "@smartsuite/types";

const tooltipPlacements: Placements = ["top", "bottom"];

export const TimeZoneBadge: FunctionComponent<{
  automation: AutomationCandidate;
}> = ({ automation }) => {
  const [displayModal, setDisplayModal] = useState<boolean>(false);

  const getTimezoneAbbreviation = (): string => {
    const timezone: string = automation.timezone ?? "";
    const timezoneAbbreviation = getTimezoneShortLabel(timezone) ?? "";
    return timezoneAbbreviation === "" ? timezone : timezoneAbbreviation;
  };

  return (
    <S.Container>
      <S.Body onClick={() => setDisplayModal(true)}>
        <S.Content>
          <Text size="s">{t("timezone.automation-timezone")}:</Text>
          {" "}
          <Text size="s" weight="medium">
            {automation.timezone === ""
              ? `<${t("timezone.not-set")}>`
              : getTimezoneAbbreviation()}
          </Text>
        </S.Content>
        <S.Edit>
          <Icon name="edit-smaller" color="currentColor" transition />
        </S.Edit>
      </S.Body>

      <S.Info>
        <Tooltip
          display="inline-flex"
          maxWidth={360}
          padding={0}
          placements={tooltipPlacements}
          text={t("timezone.tooltip-text")}
          target={
            <TooltipButton
              iconSize="S"
              iconName="info-filled"
              colors={{
                hover: GrayColors["G-7"],
              }}
            />
          }
        />
      </S.Info>
      {displayModal && (
        <TimeZoneModal
          onClose={() => setDisplayModal(false)}
          onSave={(timezone) => {
            setDisplayModal(false);
            automation.timezone = timezone;
          }}
        />
      )}
    </S.Container>
  );
};
